import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import SidebarPanel from './SidebarPanel';

class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOADING: true, 
            Notifications: false,
            Password: '',
            Password2: '',
            Updated: false,
            CUSTOMER_DET: ''
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let err = 0;
        if ($('#frmPassword')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmPassword')[0].classList.add('was-validated');

        const password = $('#txtpassword').val().trim();
        const password2 = $('#txtpassword2').val().trim();

        if(password!=password2)
        {
            err++;
            $('#txtpassword2').val('');
        }

        if(err==0)
        {
			var pass = $('#txtpassword').val();
			$('#txtpassword').val(window.b64_md5(pass));

			var pass2 = $('#txtpassword2').val();
			$('#txtpassword2').val(window.b64_md5(pass2));

			$('#submitLoading').css('display','block');
            
            const method = "POST";
            const body = new FormData(this.form);
            //console.log(body);
            var that = this;
            fetch("https://m.donedelivery.in/api/accountupdate_api2.php", { method, body })
            .then(function (response) {
                //console.log(response);
                return response.json();
            })
            .then(function (result) {

                //console.log(result);
                //alert(result);
                let updated = false;
                let notify = '';
                if(result.err!='' && result.err!=undefined)
                {
                    if(result.err=='1') notify = 'Invalid Customer Details';
                    else if(result.err=='2') notify = 'Invalid Access Detected';
                }
                else
                    updated = true;

                that.setState({ Notifications: notify, Updated:updated, Password:'', Password2:''});
                $('#submitLoading').css('display','none');
                if(notify!='')
                    $('#ModalAlert').modal('show');
                if(updated)
                    $('#ModalUpdated').modal('show');
          });
        }
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, CUSTOMER_DET:CUSTOMER_DET });
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        var customer = localStorage.getItem('userData');
        this.fetchCustomerProfile('PROFILE',customer);
    }
    
    render() { 

        if(localStorage.getItem('userData')==null)
        {
	        return (<Redirect to={'/home'}/>)
        }
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/profile';
        let AppHeaderTitle = 'Change Password';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="login-form mt-1">
                        <div className="section pt-6">
                            <img src="/assets/img/done-image.png" alt="image" className="form-image imaged w140" />
                        </div>
                        <div className="section mt-5 mb-5 pr-3 pl-3">
                            <form id="frmPassword" encType="multipart/form-data" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                                <input type="hidden" value="UPDATE2" className="form-control" name="mode" id="mode"  />
                                <input type="hidden" value={localStorage.getItem('userData')} className="form-control" name="customer" id="customer" />
                                <div className="form-group boxed mb-1">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="txtpassword">Enter New Password</label>
                                        <input type="password" className="square-inputbox form-control" name="txtpassword" id="txtpassword" minLength="8" required defaultValue={this.state.Password} autoComplete="off"/> {/*pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" */}
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                        <div className="valid-feedback">&nbsp;</div> 
                                        <div className="invalid-feedback">Must contain at least 8 or more characters.</div>
                                    </div>
                                </div>
                                <div className="form-group boxed mb-1">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="txtpassword2">Re-enter New Password</label>
                                        <input type="password" className="square-inputbox form-control" name="txtpassword2" id="txtpassword2" minLength="8" required defaultValue={this.state.Password2} autoComplete="off"/> {/* pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"*/}
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                        <div className="valid-feedback">&nbsp;</div> 
                                        <div className="invalid-feedback">Must contain at least 8 or more characters.</div>
                                    </div>
                                </div>
                                <div className="form-button-group pl-4 pr-4 bg-common">
                                    <button type="submit" className="lt-space1 text-upper btn btn-danger btn-block square btn-md">
                                    <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                                        Save</button>
                                </div>
                            </form>
                        </div>
                        <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-icon text-danger">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </div>
                                    <div className="modal-body"> 
                                            {this.state.Notifications} 
                                    </div>
                                    <div className="modal-footer">
                                        <div className="btn-inline"> 
                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade dialogbox" id="ModalUpdated" data-backdrop="static" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-icon text-success">
                                        <ion-icon name="checkmark-circle"></ion-icon>
                                    </div>
                                    <div className="modal-body"> 
                                        Password Details Updated Successfully 
                                    </div>
                                    <div className="modal-footer">
                                        <div className="btn-inline"> 
                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default ChangePassword;


// WEBPACK FOOTER //
// ./src/components/ChangePassword.js